import { render, staticRenderFns } from "./ShipmentDetailsNotAvailable.vue?vue&type=template&id=6cf75a84&"
import script from "./ShipmentDetailsNotAvailable.vue?vue&type=script&lang=js&"
export * from "./ShipmentDetailsNotAvailable.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDetailsNotAvailable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cf75a84')) {
      api.createRecord('6cf75a84', component.options)
    } else {
      api.reload('6cf75a84', component.options)
    }
    module.hot.accept("./ShipmentDetailsNotAvailable.vue?vue&type=template&id=6cf75a84&", function () {
      api.rerender('6cf75a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/ShipmentDetailsNotAvailable.vue"
export default component.exports